import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, unref as _unref, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }

import SogPage from '@/shared/ui/SogPage.vue';
import SogCardTitle from '@/shared/ui/SogCardTitle.vue';
import {computed, onMounted, ref} from 'vue';
import apiInsuranceExportBlank from '../api';

import InsuranceExportBlank, {InsuranceExportBlankStatus} from "@/shared/model/InsuranceExportBlank";

import InsuranceExportBlankDetailsComponent
  from '@/modules/InsuranceExportBlank/components/InsuranceExportBlankDetailsComponent.vue'
import SogCard from '@/shared/ui/SogCard.vue';

import apiHistory from "@/modules/History/api";
import History from "@/shared/model/History";
import SogCardContent from '@/shared/ui/SogCardContent.vue';
import HistoryListComponent from '@/modules/History/components/HistoryListComponent.vue';
import {SogButtonKind} from '@/shared/ui/types/SogButtonKind';
import {useSpinner} from '@/shared/composables/SogSpinner';
import SogCardActionButton from '@/shared/ui/SogCardActionButton.vue';
import SogCardActions from '@/shared/ui/SogCardActions.vue';
import {useAccountStore} from '@/stores/accountStore';
import getGuid from '@/shared/utils/getGuid';
import ListFile from '@/shared/model/ListFile';
import apiFileUtils from '@/modules/FileUtils/api';
import SogSkeleton from '@/shared/ui/SogSkeleton.vue';
import TempFileFormComponent from '@/modules/FileUtils/components/TempFileFormComponent.vue';
import notificationService from '@/shared/services/NotificationService';
import FileCardComponent from '@/modules/FileUtils/components/FileCardComponent.vue';
import FileInfo from "@/shared/model/FileInfo";
import apiFile from '@/shared/services/apiFile';

interface Props {
  id?: string
}


export default /*@__PURE__*/_defineComponent({
  __name: 'InsuranceExportBlankDetailsPage',
  props: {
    id: { default: undefined }
  },
  setup(__props: any) {


const props = __props


const _tempFileInfo = ref<FileInfo>()

const _insuranceExportBlank = ref<InsuranceExportBlank | undefined>();
const _history = ref<History[]>();
const _files = ref<ListFile[]>()

const _uploaderVisible = ref<boolean>(false)


const _loadingDetails = ref<boolean>(true);
const _loadingHistory = ref<boolean>(true);
const _loadingUploader = ref<boolean>(true);

const _detailsSpinner = useSpinner('details')
// const _historySpinner = useSpinner('history')
const _uploaderSpinner = useSpinner('uploader')

const _acountStote = useAccountStore();

const _uploader = ref<InstanceType<typeof TempFileFormComponent>>()
const _uploading = ref<boolean>(false)

const _isArchivedVisible = computed(() => {
  return _acountStote.isRoot && _insuranceExportBlank.value?.status !== InsuranceExportBlankStatus.Archived && (_files.value?.length ?? 0) > 0 && _insuranceExportBlank.value?.status !== InsuranceExportBlankStatus.Destroyed
})

const _isImportAndArchivedVisible = computed(() => {
  return _tempFileInfo.value && _acountStote.isRoot && _insuranceExportBlank.value?.status !== InsuranceExportBlankStatus.Archived && _insuranceExportBlank.value?.status !== InsuranceExportBlankStatus.Destroyed
})


const _isIncorectFilledVisible = computed(() => {
  return _insuranceExportBlank.value?.status === null
})

const _isCanceldVisible = computed(() => {
  // isRoot and not archived
  return _acountStote.isRoot && _insuranceExportBlank.value?.status !== InsuranceExportBlankStatus.Canceled && _insuranceExportBlank.value?.status !== InsuranceExportBlankStatus.Destroyed
})

const _isDestroyedVisible = computed(() => {
  // isRoot and not archived
  return _acountStote.isRoot && _insuranceExportBlank.value?.status === InsuranceExportBlankStatus.Canceled
})


function setUploaderVisiblity(visibility: boolean) {
  _uploaderVisible.value = visibility
  _uploader.value?.clear()
}

async function setState(state: InsuranceExportBlankStatus | undefined) {
  _detailsSpinner.show()
  await apiInsuranceExportBlank.setStatus(props.id, state)
  _detailsSpinner.hide()

  await refresh()
}

onMounted(async () => {
  refresh()
})

function onDelete(file: ListFile) {
  notificationService.showYesNo(
    "Datei löschen",
    "Soll die Datei " + file.name + " wirklich gelöscht werden?",
    async () => {
      const res = await apiFileUtils.deleteFile(file?.id ?? "");
      if (res) {
        notificationService.success("Datei " + file.name + " wurde gelöscht");
        _files.value = _files.value?.filter((f) => f.id !== file.id);
      } else
        notificationService.error(
          "Datei " + file.name + " konnte nicht gelöscht werden"
        );
    }
  );
}

function onTakePhoto() {
  _uploading.value = true;
  _uploaderVisible.value = true
  _uploader.value?.takePhoto();
}

async function onDownload(file: ListFile) {
  if (!file.personId) return;
  try {
    _uploaderSpinner.show();
    const fileId = await apiFileUtils.initDownloadFile(file.id ?? "");
    if (fileId) await apiFile.downloadTempFile(fileId);
  } finally {
    _uploaderSpinner.hide();
  }
}

const _key = ref<string>()

async function refresh() {

  if (props.id == undefined) return

  _key.value = getGuid()

  const detailLoader = loadDetails(_key.value)
  const historyLoader = loadHistory(_key.value)
  const fileLoader = loadFiles(_key.value)

  await Promise.allSettled([detailLoader, historyLoader, fileLoader])
}

async function loadDetails(key: string) {
  _loadingDetails.value = true
  const res = await apiInsuranceExportBlank.load(props.id!)

  if (key === _key.value) {
    _insuranceExportBlank.value = res;
    _loadingDetails.value = false

    updateUploaderVisibility()
  }
  return true;
}

function updateUploaderVisibility() {
  if (!(_insuranceExportBlank.value?.status === InsuranceExportBlankStatus.Canceled || _insuranceExportBlank.value?.status === InsuranceExportBlankStatus.Archived) && _acountStote.isRoot && _files.value?.length === 0) {
    _uploaderVisible.value = true
  }
}

async function loadHistory(key: string) {
  _loadingHistory.value = true
  const res = await apiHistory.listInsuranceExportBlank(props.id!)

  if (key === _key.value) {
    _history.value = res
    _loadingHistory.value = false
  }
}

async function loadFiles(key: string) {
  _loadingUploader.value = true
  const res = await apiFileUtils.listFileStore(props.id!)

  if (key === _key.value) {
    _files.value = res
    _loadingUploader.value = false

    updateUploaderVisibility()
  }
}


async function onImport(): Promise<boolean> {
  if (!_tempFileInfo.value || !_tempFileInfo.value.id)
    return false;
  const res = await apiInsuranceExportBlank.addTempFile(_tempFileInfo.value.id, _insuranceExportBlank.value?.id, _tempFileInfo.value.name, _tempFileInfo.value.fileName);
  if (res) {
    notificationService.success("Datei " + _tempFileInfo.value.name + " wurde gespeichert")
    _tempFileInfo.value = undefined
    _uploader.value?.clear()
    _uploading.value = false
    refresh()
    return true
  }
  return false
}

async function onImportAndArchived() {
  if (await onImport()) {
    await setState(InsuranceExportBlankStatus.Archived)
    await refresh()
  }
}


function onDestroy() {
  notificationService.showYesNo(
    "Ausfuhrformular vernichten",
    "Möchten Sie die Ausfuhrvormular endgültig vernichten?",
    async () => {
      await setState(InsuranceExportBlankStatus.Destroyed)
    }
  );
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SogPage, {
    id: "page",
    title: "Ausfuhrformular"
  }, {
    default: _withCtx(() => [
      _createVNode(SogCard, { id: "details" }, {
        default: _withCtx(() => [
          _createVNode(SogCardTitle, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_insuranceExportBlank.value?.blankNumber), 1)
            ]),
            _: 1
          }),
          (!_loadingDetails.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(SogCardActions, { "is-toolbar": true }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(SogCardActionButton, {
                      "mdi-icon": "mdi-pencil-off",
                      tooltip: "Status als falsch ausgefüllt setzen",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (setState(_unref(InsuranceExportBlankStatus).IncorrectlyFilled)))
                    }, null, 512), [
                      [_vShow, _isIncorectFilledVisible.value]
                    ]),
                    (_insuranceExportBlank.value?.status === _unref(InsuranceExportBlankStatus).IncorrectlyFilled)
                      ? (_openBlock(), _createBlock(SogCardActionButton, {
                          key: 0,
                          "mdi-icon": "mdi-pencil",
                          tooltip: "Status als gültig setzen",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (setState(undefined)))
                        }))
                      : _createCommentVNode("", true),
                    (_isCanceldVisible.value)
                      ? (_openBlock(), _createBlock(SogCardActionButton, {
                          key: 1,
                          "mdi-icon": "mdi-delete-outline",
                          tooltip: "Status als ungültig setzen",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (setState(_unref(InsuranceExportBlankStatus).Canceled)))
                        }))
                      : _createCommentVNode("", true),
                    (_isDestroyedVisible.value)
                      ? (_openBlock(), _createBlock(SogCardActionButton, {
                          key: 2,
                          "mdi-icon": "mdi-eye-remove",
                          tooltip: "Mit 'vier Augen'-Prinzip physikalisch vernichten",
                          onClick: _cache[3] || (_cache[3] = ($event: any) => (onDestroy()))
                        }))
                      : _createCommentVNode("", true),
                    (_isArchivedVisible.value)
                      ? (_openBlock(), _createBlock(SogCardActionButton, {
                          key: 3,
                          "mdi-icon": "mdi-archive",
                          tooltip: "Status als archiviert setzen",
                          onClick: _cache[4] || (_cache[4] = ($event: any) => (setState(_unref(InsuranceExportBlankStatus).Archived)))
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(SogCardActionButton, {
                      "mdi-icon": "mdi-paperclip-plus",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (setUploaderVisiblity(true)))
                    }),
                    _createVNode(SogCardActionButton, {
                      "mdi-icon": "mdi-camera",
                      tooltip: "Anhang fotografieren",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (onTakePhoto()))
                    }),
                    _createVNode(SogCardActionButton, {
                      kind: _unref(SogButtonKind).Refresh,
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (refresh()))
                    }, null, 8, ["kind"]),
                    _createVNode(SogCardActionButton, {
                      kind: _unref(SogButtonKind).Back
                    }, null, 8, ["kind"])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(SogCardContent, null, {
            default: _withCtx(() => [
              (_loadingDetails.value)
                ? (_openBlock(), _createBlock(SogSkeleton, { key: 0 }))
                : _createCommentVNode("", true),
              (!_loadingDetails.value)
                ? (_openBlock(), _createBlock(InsuranceExportBlankDetailsComponent, {
                    key: 1,
                    "insurance-export-blank": _insuranceExportBlank.value
                  }, null, 8, ["insurance-export-blank"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(TempFileFormComponent, {
        id: "uploader",
        ref_key: "_uploader",
        ref: _uploader,
        modelValue: _tempFileInfo.value,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_tempFileInfo).value = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(SogCardActions, null, {
            default: _withCtx(() => [
              (_isImportAndArchivedVisible.value)
                ? (_openBlock(), _createBlock(SogCardActionButton, {
                    key: 0,
                    "mdi-icon": "mdi-archive",
                    tooltip: "Importieren und Status als archiviert setzen",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (onImportAndArchived()))
                  }))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(SogCardActionButton, {
                "mdi-icon": "mdi-upload",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (onImport()))
              }, {
                default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                  _createTextVNode(" Importieren ", -1)
                ]))]),
                _: 1
              }, 512), [
                [_vShow, _tempFileInfo.value]
              ]),
              _createVNode(SogCardActionButton, {
                kind: _unref(SogButtonKind).Cancel,
                onClick: _cache[10] || (_cache[10] = ($event: any) => (setUploaderVisiblity(false)))
              }, null, 8, ["kind"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]), [
        [_vShow, !_loadingUploader.value && _uploaderVisible.value]
      ]),
      ((_history.value != null && _history.value!.length > 0) || _loadingHistory.value)
        ? (_openBlock(), _createBlock(SogCard, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(SogCardTitle, null, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode("Historie", -1)
                ]))]),
                _: 1
              }),
              _createVNode(SogCardContent, null, {
                default: _withCtx(() => [
                  (_loadingHistory.value)
                    ? (_openBlock(), _createBlock(SogSkeleton, { key: 0 }))
                    : _createCommentVNode("", true),
                  (!_loadingHistory.value)
                    ? (_openBlock(), _createBlock(HistoryListComponent, {
                        key: 1,
                        data: _history.value
                      }, null, 8, ["data"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!_loadingUploader.value && _files.value?.length !== 0)
        ? (_openBlock(), _createBlock(SogCard, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(SogCardTitle, null, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("Anhänge", -1)
                ]))]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_files.value, (file) => {
                return (_openBlock(), _createBlock(SogCardContent, {
                  key: file.id
                }, {
                  default: _withCtx(() => [
                    _createVNode(FileCardComponent, { file: file }, {
                      default: _withCtx(() => [
                        _createVNode(SogCardActionButton, {
                          "mdi-icon": "mdi-delete",
                          tooltip: "Löschen",
                          onClick: ($event: any) => (onDelete(file))
                        }, null, 8, ["onClick"]),
                        _createVNode(SogCardActionButton, {
                          "mdi-icon": "mdi-download",
                          tooltip: "Download",
                          onClick: ($event: any) => (onDownload(file))
                        }, null, 8, ["onClick"])
                      ]),
                      _: 2
                    }, 1032, ["file"])
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})